let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aLO3b")).then(() => parcelRequire('kNekD'));